import React from 'react'
import styled from 'styled-components'

interface Props {
  title?: React.ReactNode
  icon?: React.ReactNode
  action?: React.ReactNode
  banner?: React.ReactNode
  body?: React.ReactNode
  children?: React.ReactNode
}

export const SettingsDataCard: React.FC<Props> = ({
  title,
  icon,
  action,
  banner,
  body,
  children
}) => {
  const showHeader = Boolean(title || action || icon)

  return (
    <Card>
      {showHeader && (
        <Header>
          {icon ? <HeaderIcon>{icon}</HeaderIcon> : null}
          {title ? <Title>{title}</Title> : null}
          {action ? <HeaderAction>{action}</HeaderAction> : null}
        </Header>
      )}
      {banner ? <Banner>{banner}</Banner> : null}
      {children != null && children !== false ? <Rows>{children}</Rows> : null}
      {body != null && body !== false ? <Body>{body}</Body> : null}
    </Card>
  )
}

const Card = styled.section`
  background: ${({ theme }) => theme.colors.neutralWhite};
  border: 1px solid ${({ theme }) => theme.colors.borderSoft};
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  overflow: hidden;
  min-width: 0;
`

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm}rem;
  padding: ${({ theme }) => theme.spacing.md}rem;
  border-bottom: 1px solid ${({ theme }) => theme.colors.neutralGray};
`

const HeaderIcon = styled.span`
  flex: 0 0 ${({ theme }) => theme.iconSize.md}rem;
  width: ${({ theme }) => theme.iconSize.md}rem;
  height: ${({ theme }) => theme.iconSize.md}rem;
  border-radius: ${({ theme }) => theme.borderRadius.sm}rem;
  background: ${({ theme }) => theme.dashboard.infoTint};
  color: ${({ theme }) => theme.dashboard.infoDeep};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: ${({ theme }) => theme.fontSize.px14}rem;
    height: ${({ theme }) => theme.fontSize.px14}rem;
  }
`

const Title = styled.h3`
  flex: 1;
  min-width: 0;
  color: ${({ theme }) => theme.colors.menuBg};
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  font-weight: 600;
  margin: 0;
`

const HeaderAction = styled.div`
  flex-shrink: 0;
`

const Banner = styled.div`
  padding: ${({ theme }) => theme.spacing.md}rem ${({ theme }) => theme.spacing.md}rem 0;
`

const Rows = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  padding: ${({ theme }) => theme.spacing.md}rem;

  > * + * {
    border-top: 1px solid ${({ theme }) => theme.dashboard.surfaceSubtle};
  }
`

const Body = styled.div`
  padding: ${({ theme }) => theme.spacing.md}rem;
`
